
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import Icon from 'components/Icon'
import classnames from 'classnames'

export default class PromptContainer extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    className: PropTypes.string,
    onClose: PropTypes.func
  }

  render() {
    const {children, className, title} = this.props
    const classNames = classnames('prompt-container_modal', className, {
      'with-title': !!title
    })

    return (
      <div className='prompt-container' onClick={this.onClick}>
        <div className={classNames} onClick={e => e.stopPropagation()}>
          {this.renderTitle()}
          {this.renderCloseIcon()}
          <div className='prompt-container_modal-body'>
            {children}
          </div>
        </div>
      </div>
    )
  }

  renderCloseIcon() {
    const {onClose} = this.props

    if (!onClose) return null

    return (
      <Icon
        className='prompt-container_modal-header_close-icon'
        name='delete'
        size='10px'
        onClick={onClose}
      />
    )
  }

  renderTitle() {
    const {title} = this.props

    if (!title) return null

    return (
      <div className='prompt-container_modal-header'>
        {title}
      </div>
    )
  }

  onClick = e => {
    const {onClose} = this.props
    e.stopPropagation()

    onClose && onClose()
  }
}



// WEBPACK FOOTER //
// ./client/components/PromptContainer/index.js